import React, { Component } from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import ProgressBar from 'react-bootstrap/ProgressBar';

import { AgolService } from '../../services/Agol';

import './Home.scss';

import '../../components/CardInfoTable/CardInfoTable.css';
import '../../components/CardInfoChart/CardInfoChart.css';

import { CardMap } from '../../components/CardMap/CardMap';
import { CardChart } from '../../components/CardChart/CardChart';

import { MdDirectionsWalk, MdRemoveRedEye } from 'react-icons/md';
import { FaPlusSquare } from 'react-icons/fa';

import CustomTooltip from '../../components/CustomTooltip/CustomTooltip';
import { CustomIconIndicator } from '../../components/CustomIconIndicator/CustomIconIndicator';

import { Header } from '../../components/Header/Header';
import iconVirus from '../../assets/virus.svg';

import Table from 'react-bootstrap/Table';
import { FormatterUtils } from '../../utils/formatter.utils';

import numeral from 'numeral';

import moment from 'moment';
import 'moment/locale/pt-br';
import { CardInfoNumber } from '../../components/CardInfoNumber/CardInfoNumber';

const localeId = 'pt-br';
moment.locale(localeId);

numeral.register(
  'locale',
  localeId,
  Object.assign({}, numeral.locales.en, {
    delimiters: {
      thousands: '.',
      decimal: ',',
    },
    abbreviations: {
      thousand: 'k',
      million: 'M',
      billion: 'b',
      trillion: 't',
    },
    currency: {
      symbol: 'R$',
    },
  })
);
numeral.locale(localeId);

export interface HomeProps {

}

type HomeState = {
  propsInfoHeader: any,
  propsDataHeader: any,
  propsInfoIndicator: any[],
  propsDataIndicator: any[],
  propsDataTable: any[],
  propsInfoIndicatorChart: any[],
  propsDataIndicatorChart: any[],
  categories: any[],
  categorySelected: string,
  webMap: string,
  webMapTitle: string,
  cardWebmapSelectedIndex: number,
  mapInitialSearch?: string,
  region?: string,
  codMun: string,
  codUF: string,
  loadingVisible: boolean,
  error: boolean,
}

export class Home extends Component<HomeProps, HomeState> {
  webmapId = '';
  requestDataId = 0;

  mapInitialized?: boolean;

  private propsInfoHeaderPromise?: Promise<any>;

  constructor(props: Readonly<HomeProps>) {
    super(props);

    const categories = [
      { text: 'População vulnerável', icon: MdDirectionsWalk },
      {
        text: 'Capacidade de resposta do Sistema de Saúde',
        icon: FaPlusSquare,
      },
      { text: 'Acompanhamento da pandemia', icon: iconVirus },
    ];

    this.state = {
      propsInfoHeader: {},
      propsDataHeader: {},
      propsInfoIndicator: [],
      propsDataIndicator: [],
      propsDataTable: [],
      propsInfoIndicatorChart: [],
      propsDataIndicatorChart: [],
      categories,
      categorySelected: categories[0].text,
      webMap: this.webmapId,
      webMapTitle: '',
      cardWebmapSelectedIndex: -1,
      region: '',
      codMun: '3550308', // São Paulo
      codUF: '35', // SP
      loadingVisible: true,
      error: false,
    };
  }

  componentDidMount() {
    this.getDataAgol(++this.requestDataId);
  }

  componentWillUnmount() {
    ++this.requestDataId;
  }

  onBtnCategoryClick = (category: string) => {
    if (this.state.categorySelected === category) {
      return;
    }
    this.setState({ categorySelected: category, cardWebmapSelectedIndex: -1 });
    this.getDataAgol(++this.requestDataId);
  };

  onSearchResult = (e: __esri.SearchSelectResultEvent) => {
    if (!this.mapInitialized) {
      return;
    }
    const propsDataHeader = e.result.feature.attributes;
    const codMun =
      propsDataHeader[this.state.propsInfoHeader.cod_ligacao_busca];
    const codUF =
      propsDataHeader.cd_uf ||
      propsDataHeader.cod_uf ||
      propsDataHeader.codUf ||
      propsDataHeader.coduf ||
      propsDataHeader.CD_UF ||
      propsDataHeader.COD_UF ||
      propsDataHeader.CodUf;
    const region = propsDataHeader[this.state.propsInfoHeader.campo_busca];
    this.setState({ propsDataHeader, codMun, codUF, region });
    this.getDataAgol(++this.requestDataId);
  };

  getDataAgol(requestDataId) {
    if (this.requestDataId !== requestDataId) {
      return Promise.resolve();
    }

    this.setState({ loadingVisible: true, error: false });

    if (!this.propsInfoHeaderPromise) {
      this.propsInfoHeaderPromise = AgolService.getParamHeader().then((res) => {
        this.setState({ propsInfoHeader: res.data.features[0].attributes });
      });
    }
    return this.propsInfoHeaderPromise
      .then(() => {
        if (this.requestDataId !== requestDataId) {
          return;
        }

        return AgolService.getDataHeader(
          this.state.propsInfoHeader,
          this.state.codMun
        )
          .then(async (res) => {
            if (this.requestDataId !== requestDataId) {
              return;
            }
            this.setState({ propsDataHeader: res.data.features[0].attributes });

            return Promise.all([
              AgolService.getParamIndicators(this.state.categorySelected)
                .then((res) => {
                  if (this.requestDataId !== requestDataId) {
                    return;
                  }
                  this.setState({ propsInfoIndicator: res.data.features });

                  let cacheLevel1Aux = new Map();
                  let promises = this.state.propsInfoIndicator.map((item) => {
                    let requests = [
                      [
                        item.attributes.camada_destaque,
                        item.attributes.cod_ligacao_destaque,
                        this.state.codMun,
                      ],
                      [
                        item.attributes.camada_secundaria,
                        item.attributes.cod_ligacao_secundario,
                        this.state.codMun,
                      ],
                      [
                        item.attributes.camada_feature_layer_ref,
                        item.attributes.cod_ligacao_secundario_destaque,
                        this.state.codUF,
                      ],
                    ].map(([layerUrl, codLig, value]) => {
                      if (!layerUrl || !codLig || !value) {
                        return;
                      }

                      let cacheLevel2Aux;
                      if (cacheLevel1Aux.has(layerUrl)) {
                        cacheLevel2Aux = cacheLevel1Aux.get(layerUrl);
                      } else {
                        cacheLevel2Aux = new Map();
                        cacheLevel1Aux.set(layerUrl, cacheLevel2Aux);
                      }

                      let promiseAux;
                      if (cacheLevel2Aux.has(codLig)) {
                        promiseAux = cacheLevel2Aux.get(codLig);
                      } else {
                        promiseAux = AgolService.getData({
                          value: value,
                          cod_ligacao: codLig,
                          camada: layerUrl,
                        });
                        cacheLevel2Aux.set(codLig, promiseAux);
                      }

                      return promiseAux.then((res) => {
                        if (
                          this.requestDataId !== requestDataId ||
                          res.data.error
                        ) {
                          return;
                        }

                        return {
                          fields: res?.data?.fields,
                          attributes: res?.data?.features[0]?.attributes
                        };
                      });
                    });

                    return Promise.all(requests)
                      .then(([destaque, secundario, referencia]) => {
                        if (this.requestDataId !== requestDataId) {
                          return;
                        }
                        return {
                          info: item.attributes,
                          data: { destaque, secundario, referencia },
                        };
                      })
                      .catch((err) => {
                        console.error(
                          `ERRO BUSCAR DADOS INDICADORES_EM_DESTAQUE - camada_destaque! => ${err}`
                        );
                        throw err;
                      });
                  });

                  return Promise.all(promises).then(
                    async (resulDataIndicator) => {
                      if (this.requestDataId !== requestDataId) {
                        return;
                      }
                      resulDataIndicator = resulDataIndicator.filter(
                        (x) => !!x
                      );
                      let cardWebmapSelectedIndex = this.state
                        .cardWebmapSelectedIndex;
                      let webMap = this.state.webMap;
                      let webMapTitle = this.state.webMapTitle;
                      if (
                        cardWebmapSelectedIndex < 0 &&
                        resulDataIndicator.length > 0
                      ) {
                        const info =
                          resulDataIndicator[(cardWebmapSelectedIndex = 0)]
                            ?.info;
                        webMap = info?.webmap;
                        webMapTitle = info?.nome_indicador;
                      }

                      const newState: any = {
                        propsDataIndicator: resulDataIndicator,
                        cardWebmapSelectedIndex,
                        webMap,
                        webMapTitle,
                      };

                      if (!this.mapInitialized) {
                        newState.mapInitialSearch = this.state.propsDataHeader[
                          this.state.propsInfoHeader.campo_busca
                        ];
                        this.mapInitialized = true;
                      }

                      this.setState(newState);
                    }
                  );
                })
                .catch((err) => {
                  console.error(
                    `ERRO BUSCAR DADOS INDICADORES_EM_DESTAQUE! => ${err}`
                  );
                  throw err;
                }),
              AgolService.getParamIndicatorChart(this.state.categorySelected)
                .then((res) => {
                  if (this.requestDataId !== requestDataId) {
                    return;
                  }
                  this.setState({ propsInfoIndicatorChart: res.data.features });

                  let cacheLevel1 = new Map();
                  let promises = this.state.propsInfoIndicatorChart.map(
                    (item) => {
                      let cacheLevel2;
                      if (cacheLevel1.has(item.attributes.camada_destaque)) {
                        cacheLevel2 = cacheLevel1.get(
                          item.attributes.camada_destaque
                        );
                      } else {
                        cacheLevel2 = new Map();
                        cacheLevel1.set(
                          item.attributes.camada_destaque,
                          cacheLevel2
                        );
                      }

                      let promiseAux;
                      if (
                        cacheLevel2.has(item.attributes.cod_ligacao_destaque)
                      ) {
                        promiseAux = cacheLevel2.get(
                          item.attributes.cod_ligacao_destaque
                        );
                      } else {
                        promiseAux = AgolService.getData({
                          value: this.state.codMun,
                          cod_ligacao: item.attributes.cod_ligacao_destaque,
                          camada: item.attributes.camada_destaque,
                        }).catch(
                          (err) => {
                            console.error(
                              `ERRO BUSCAR DADOS INDICADORES_GRAFICO_BARRAS - camada_destaque! => ${err}`
                            );
                            throw err;
                          }
                        );
                        cacheLevel2.set(
                          item.attributes.cod_ligacao_destaque,
                          promiseAux
                        );
                      }

                      return promiseAux.then((res) => {
                        if (this.requestDataId !== requestDataId) {
                          return;
                        }
                        if (!res.data.error) {
                          let result = {
                            info: item.attributes,
                            data: res.data.features[0].attributes,
                          };

                          return result;
                        }
                      });
                    }
                  );

                  return Promise.all(promises).then((resulDataIndicator) => {
                    if (this.requestDataId !== requestDataId) {
                      return;
                    }
                    resulDataIndicator = resulDataIndicator.filter((x) => !!x);
                    const indicatorNames = new Set(
                      resulDataIndicator.map((x) => x.info.nome_indicador)
                    );
                    const chartIndicatorObject = new Array(indicatorNames.size);
                    let i = -1;
                    for (let item of indicatorNames.values()) {
                      let data = resulDataIndicator.filter((x) => {
                        if (x.info.nome_indicador === item) return x.data;
                      });
                      chartIndicatorObject[++i] = {
                        indicadorName: item,
                        values: data,
                        link: data[0]?.info?.link,
                      };
                    }

                    this.setState({
                      propsDataIndicatorChart: chartIndicatorObject,
                    });
                  });
                })
                .catch((err) => {
                  console.error(
                    `ERRO BUSCAR DADOS INDICADORES_GRAFICO_BARRAS! => ${err}`
                  );
                  throw err;
                }),
              AgolService.getParamTable(this.state.categorySelected)
                .then((res) => {
                  if (this.requestDataId !== requestDataId) {
                    return;
                  }
                  let propsInfoTable = res?.data?.features ?? [];

                  let cacheLevel1 = new Map();
                  let promises = propsInfoTable
                    .map((item) => {
                      let promisesAux = [
                        [
                          item.attributes.camada_destaque,
                          item.attributes.cod_ligacao_destaque,
                          null,
                          item.attributes.campo_destaque,
                          item.attributes.unidade_destaque,
                        ],
                        [
                          item.attributes.camada_secundaria,
                          item.attributes.cod_ligacao_secundario,
                          null,
                          item.attributes.campo_secundario,
                          item.attributes.unidade_secundario_destaque,
                        ],
                        [
                          item.attributes.camada_feature_layer_ref,
                          item.attributes.cod_ligacao_secundario_destaque,
                          item.attributes.tipo_ligacao_referencia,
                          item.attributes.campo_referencia,
                          item.attributes.unidade_referencia,
                        ],
                      ].map(([layerUrl, fieldLink, typeFieldLink, field, unit]) => {
                        if (!layerUrl || !fieldLink || !field) {
                          return;
                        }
                        let cacheLevel2;
                        if (cacheLevel1.has(layerUrl)) {
                          cacheLevel2 = cacheLevel1.get(layerUrl);
                        } else {
                          cacheLevel2 = new Map();
                          cacheLevel1.set(layerUrl, cacheLevel2);
                        }

                        let promiseAux;
                        if (cacheLevel2.has(fieldLink)) {
                          promiseAux = cacheLevel2.get(fieldLink);
                        } else {
                          promiseAux = AgolService.getData({
                            value: typeFieldLink === 'UF' ? this.state.codUF : this.state.codMun,
                            cod_ligacao: fieldLink,
                            camada: layerUrl,
                          }).catch(
                            (err) => {
                              console.error(
                                `ERRO BUSCAR DADOS INDICADORES_EM_DESTAQUE - camada_destaque! => ${err}`
                              );
                              throw err;
                            }
                          );
                          cacheLevel2.set(fieldLink, promiseAux);
                        }

                        return promiseAux.then((res) => {
                          if (this.requestDataId !== requestDataId) {
                            return;
                          }
                          if (!res.data.error) {
                            const fields = res?.data?.fields;
                            const attributes = res?.data?.features[0]?.attributes ?? {};
                            return {
                              unit,
                              value: attributes[field],
                              fields,
                              attributes
                            };
                          }
                        });
                      });

                      return Promise.all(promisesAux).then(
                        ([highlight, secondary, reference]) => {
                          if (this.requestDataId !== requestDataId) {
                            return;
                          }

                          if (!highlight && !secondary && !reference) {
                            return;
                          }

                          const indicatorName = this.handleIndicatorNameInternal(item.attributes, highlight?.attributes, highlight?.fields)
                          return {
                            indicatorName,
                            font: item.attributes.fonte,
                            link: item.attributes.link,
                            description: item.attributes.descricao,
                            highlight,
                            secondary,
                            reference,
                          };
                        }
                      );
                    })
                    .filter((x) => !!x);

                  return Promise.all(promises).then((resulDataIndicator: any[]) => {
                    if (this.requestDataId !== requestDataId) {
                      return;
                    }
                    resulDataIndicator = resulDataIndicator.filter((x) => !!x);
                    this.setState({ propsDataTable: resulDataIndicator });
                  });
                })
                .catch((err) => {
                  console.error(
                    `ERRO BUSCAR DADOS INDICADORES_EM_TABELA! => ${err}`
                  );
                  throw err;
                }),
            ]);
          })
          .catch((err) => {
            console.error(
              `ERRO BUSCAR DADOS BARRA_DE_CIMA - camada_busca! => ${err}`
            );
            throw err;
          });
      })
      .then(async () => {
        if (this.requestDataId !== requestDataId) {
          return;
        }
        this.setState({ loadingVisible: false, error: false });
      })
      .catch((err) => {
        console.error(`ERRO BUSCAR DADOS BARRA_DE_CIMA! => ${err}`);
        if (this.requestDataId !== requestDataId) {
          return;
        }
        this.setState({ loadingVisible: false, error: true });
      });
  }

  getValueIndicator(value) {
    if (!isNaN(value)) {
      return FormatterUtils.formatNumber(value);
    }
    return '';
  }

  private handleTextValue(text: string): string {
    text = (text ?? '').replace(/ /g, '\u00a0');
    return text;
  }

  private handleIndicatorNameCard(item: any): string {
    return this.handleIndicatorNameInternal(item?.info, item?.data?.destaque?.attributes, item?.data?.destaque?.fields);
  }

  private handleIndicatorNameInternal(info: any, attributes: any, fields: any[]): string {
    let indicatorName = info?.nome_indicador ?? '';
    if (info?.nome_indicador_variavel && attributes) {
      const value = attributes[info.nome_indicador_variavel];
      if (typeof value !== 'undefined' && value !== null) {
        let text: string;
        const field = fields?.find(x => x?.name === info.nome_indicador_variavel);
        if (field?.type === 'esriFieldTypeDate') {
          text = FormatterUtils.formatDate(value);
        } else if (typeof value === 'number') {
          text = this.getValueIndicator(value);
        } else {
          text = String(value);
        }

        if (text) {
          indicatorName += text;
        }
      }
    }
    return indicatorName;
  }

  handlePercent(percent) {
    return percent || 0;
  }

  onCardWebmapClick(item, index) {
    if (item.info.webmap) {
      const indicatorTitle = this.handleIndicatorNameCard(item);
      this.setState({
        webMap: item.info.webmap,
        webMapTitle: indicatorTitle,
        cardWebmapSelectedIndex: index,
      });
    }
  }

  isLink(value) {
    value = value || '';
    return !!(value && value.startsWith('http'));
  }

  render() {
    return (
      <div className='Home'>
        <Header
          loadingVisible={this.state.loadingVisible}
          error={this.state.error}
          region={this.state.region}
          healthRegion={this.state.propsDataHeader.nomereg_baixamediacomplex}
          healthRegionTooltip={this.state.propsInfoHeader.descricao_campo_regiao}
          uf={this.state.propsDataHeader.nm_uf}
          moreWebsitesLink={'https://cidades.ibge.gov.br/municipio/' + this.state.codMun}
          downloadLink={'https://dadosgeociencias.ibge.gov.br/portal/apps/sites/#/geohub-ibge-covid-19/search?categories='}
          aboutLink={'https://dadosgeociencias.ibge.gov.br/portal/sharing/rest/content/items/5f6874de2ecc449dbc86874b080cb107/data'}
          categories={this.state.categories}
          categorySelected={this.state.categorySelected}
          onCategoryItemClick={this.onBtnCategoryClick}
        />
        <Container fluid className='bodyCustom margin-row-space-top'>
          <Row>
            <Col xs='12' md='6' className='margin-row-space-bottom'>
              <CardMap
                initialSearch={this.state.mapInitialSearch}
                webMapTitle={this.state.webMapTitle}
                webMap={this.state.webMap}
                camadaBusca={this.state.propsInfoHeader.camada_busca}
                campoBusca={this.state.propsInfoHeader.campo_busca}
                searchPlaceholder={this.state.propsInfoHeader.descricao}
                onSearchResult={this.onSearchResult} />
            </Col>
            <Col xs='12' md='6' className='margin-row-space-bottom'>
              <CardChart
                codMun={this.state.propsDataHeader.cd_mun}
                category={this.state.categorySelected}
              />
            </Col>
          </Row>
          <Row>
            {this.state.propsDataIndicator.map((item, index) => (
              <Col
                key={index.toString()}
                xs='12'
                md='6'
                lg='3'
                className='margin-row-space-bottom'
              >
                <CardInfoNumber
                  tooltip={item?.info?.descricao}
                  selected={this.state.cardWebmapSelectedIndex === index}
                  link={this.isLink(item?.info?.link) ? item.info.link : null}
                  title={this.handleIndicatorNameCard(item)}
                  highlighValue={item?.data?.destaque?.attributes
                    ? item?.data?.destaque?.attributes[item?.info?.campo_destaque]
                    : null}
                  highlighUnit={item?.info?.unidade_destaque}
                  secondaryValue={item?.data?.secundario?.attributes
                    ? item?.data?.secundario?.attributes[item?.info?.campo_secundario]
                    : null}
                  secondaryUnit={item?.info?.unidade_secundario_destaque}
                  referenceValue={item?.data?.referencia?.attributes
                    ? item?.data?.referencia?.attributes[item?.info?.campo_referencia]
                    : null}
                  referenceUnit={item?.info?.unidade_referencia}
                  onClick={() => this.onCardWebmapClick(item, index)}
                />
              </Col>
            ))}
          </Row>
          <Row>
            <Col xs='12' lg='8' className='margin-row-space-bottom'>
              <div className='full-height customCardInfoTable'>
                <div className='table-wrapper-scroll-y my-custom-scrollbar'>
                  <Table className='customTable' striped borderless={false}>
                    <thead>
                      <tr>
                        <th>Indicador</th>
                        <th className='column-quantity'>Quantidade</th>
                        <th className='column-reference'>Valor de referência</th>
                        <th className='column-font'>Fonte</th>
                        <th>Visualizar</th>
                      </tr>
                    </thead>
                    <tbody>
                      {this.state.propsDataTable.map((td, i) => (
                        <tr key={i}>
                          <td>
                            <CustomTooltip tooltip={td.description}>
                              <span>{td.indicatorName}</span>
                            </CustomTooltip>
                          </td>
                          <td>
                            <b>
                              {this.getValueIndicator(td.highlight?.value)}
                              {this.handleTextValue(td.highlight?.unit)}
                            </b>
                            <br />
                            {this.getValueIndicator(td.secondary?.value)}
                            {this.handleTextValue(td.secondary?.unit)}
                          </td>
                          <td>
                            {this.getValueIndicator(td.reference?.value)}
                            {this.handleTextValue(td.reference?.unit)}
                          </td>
                          <td>{td.font}</td>
                          <td className='align-items-center d-flex justify-content-center'>
                            <CustomIconIndicator
                              disabled={!this.isLink(td.link)}
                              link={td.link || '#'}
                            >
                              <CustomTooltip tooltip='Acesse mais informações'>
                                <MdRemoveRedEye />
                              </CustomTooltip>
                            </CustomIconIndicator>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </div>
              </div>
            </Col>
            <Col xs='12' lg='4' className='margin-row-space-bottom'>
              <Row>
                {this.state.propsDataIndicatorChart.map((item, index) => (
                  <Col
                    key={index.toString()}
                    style={{ order: item.ID }}
                    md='12'
                    className={
                      (index === 0 ? '' : ' margin-row-space-top')
                    }
                  >
                    <div className='full-height customCardInfoChart'>
                      <div className='cardInfoChartHeader'>
                        {item.indicadorName}
                      </div>
                      <CustomIconIndicator
                        className='icon-indicator'
                        disabled={!this.isLink(item.link)}
                        link={item.link || '#'}
                      >
                        <CustomTooltip tooltip='Acesse mais informações'>
                          <MdRemoveRedEye />
                        </CustomTooltip>
                      </CustomIconIndicator>
                      {item.values.map((value, index) => (
                        <div
                          key={index.toString()}
                          className='cardInfoChartInfoTitle'
                        >
                          <label>
                            {value.info.LABEL}{' '}
                            <b>
                              {this.getValueIndicator(
                                value.data[value.info.campo_destaque]
                              )}
                            </b>{' '}
                            {this.handleTextValue(value.info.unidade_destaque)}
                          </label>
                          <CustomTooltip tooltip={value.info.descricao}>
                            <ProgressBar
                              className='custom-progress-bar'
                              now={this.handlePercent(
                                value.data[value.info.campo_percentual]
                              )}
                              label={`${this.getValueIndicator(
                                this.handlePercent(
                                  value.data[value.info.campo_percentual]
                                )
                              )}%`}
                            />
                          </CustomTooltip>
                        </div>
                      ))}
                    </div>
                  </Col>
                ))}
              </Row>
            </Col>
          </Row>
        </Container>
        <div className='appFooter'></div>
      </div>
    );
  }
}
